import { HatchetLogo } from '@/components/v1/ui/hatchet-logo';
import { cn } from '@/lib/utils';

export function RunsEmptyGraphic({
  className = 'h-24 w-auto',
}: {
  className?: string;
}) {
  return (
    <HatchetLogo
      variant="mark"
      title=""
      aria-hidden="true"
      className={cn('opacity-70', className)}
    />
  );
}
